import {
  Alert,
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { GoogleButton } from "./CustomButton";
import "./Login.css";
// import { useState } from "react";

import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";

import usePersist from "../../hooks/usePersist";
import Spinner from "../../components/Spinner";

const Login = () => {
  const userRef = useRef();
  const errRef = useRef();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [persist, setPersist] = usePersist();
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [login, { isLoading }] = useLoginMutation();

  useEffect(() => {
    userRef?.current?.focus();
  }, []);

  useEffect(() => {
    if (username !== "" || password !== "") {
      setErrMsg("");
    }
  }, [username, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { accessToken } = await login({ username, password }).unwrap();
      dispatch(setCredentials({ accessToken }));
      setUsername("");
      setPassword("");
      navigate("/");
    } catch (err) {
      if (!err.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 400) {
        setErrMsg("Missing Username or Password");
      } else if (err.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg(err.data?.message);
      }
      // setUsername("");
      // setPassword("");
      // errRef?.current.focus();
    }
  };

  const handleUserInput = (e) => setUsername(e.target.value);
  const handlePwdInput = (e) => setPassword(e.target.value);
  const handleToggle = () => setPersist((prev) => !prev);

  const buttonRef = useRef(null);

  // Handle the "Enter" key down in the password input field
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current.click(); // Trigger the button click
    }
  };

  const errClass = errMsg ? "errmsg" : "offscreen";

  if (isLoading) return <Spinner />;

  return (
    <Container sx={{ marginY: 10 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper elevation={5} sx={{ minWidth: 400, padding: 3 }} span={3}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {(errMsg || errorMsg) && (
              <Alert
                variant="outlined"
                severity="error"
                ref={errRef}
                aria-live="assertive"
              >
                {errMsg || errorMsg}
              </Alert>
            )}
            <Typography variant="h4" component="h1">
              Sign in
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <GoogleButton
                setErrorMsg={setErrorMsg}
                setstyle={{ width: "100%" }}
              />
            </Box>
            <Divider>or</Divider>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <FormControl>
                <TextField
                  type="email"
                  label="Username"
                  id="username"
                  inputRef={userRef}
                  color="inherit"
                  onChange={handleUserInput}
                  onKeyDown={handleKeyDown}
                  value={username}
                  autoComplete="off"
                  required
                />
              </FormControl>
              <FormControl>
                <TextField
                  type="password"
                  label="Password"
                  id="password"
                  color="inherit"
                  onChange={handlePwdInput}
                  onKeyDown={handleKeyDown}
                  value={password}
                  required
                />
              </FormControl>
              <Button
                variant="outlined"
                color="inherit"
                size="large"
                onClick={handleSubmit}
                ref={buttonRef}
              >
                Sign in
              </Button>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="persist"
                      onChange={handleToggle}
                      checked={persist}
                    />
                  }
                  label="Remember Me"
                />
              </FormGroup>
              {/* <label htmlFor="persist" className="form__persist">
                <input
                  type="checkbox"
                  // className="form__checkbox"
                  id="persist"
                  onChange={handleToggle}
                  checked={persist}
                />
                Trust This Device
              </label> */}
              {/* <Typography sx={{ textAlign: "center" }}>
                Don&apos;t have an account?{" "}
                <span>
                  <Link
                    to="/register/"
                    variant="body2"
                    style={{ color: "inherit" }}
                  >
                    Sign up
                  </Link>
                </span>
              </Typography>*/}
            </Box>
            {/* <Divider>or</Divider>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <GoogleButton
                // setErrorMsg={setErrorMsg}
                setstyle={{ width: "100%" }}
              />
            </Box> */}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
